import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import NoAccess from "./NoAccess";

// Filial-Mitarbeiter (persoenlicher Account mit Filiale) arbeiten nur mit den Filialfunktionen;
// Groebenzell-Seiten (Druckliste, Rezepte, Lager, ...) leiten auf das Abwiegen um.
const BRANCH_STAFF_PATHS = [
  "/abwiegen",
  "/products/filiale",
  "/pickup-basket",
  "/package-scan",
  "/bestellungen-tracking",
  "/m/bestellungen",
];

const isBranchStaff = (user) => user?.aptId != null && user?.role !== "apotheke";

export default function ProtectedRoute({ children, roles, excludeRoles, cap }) {
  const { isAuthenticated, isBootstrapping, user, can } = useAuth();
  const location = useLocation();
  if (isBootstrapping) return null;
  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  if (
    isBranchStaff(user) &&
    !BRANCH_STAFF_PATHS.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`))
  ) {
    return <Navigate to="/abwiegen" replace />;
  }
  if (cap) {
    if (!user) return null;
    if (!can(cap)) return <NoAccess />;
  }
  if (roles) {
    if (!user) return null;
    if (!roles.includes(user.role)) return <Navigate to="/uebersicht" replace />;
  }
  if (excludeRoles) {
    if (!user) return null;
    if (excludeRoles.includes(user.role)) return <Navigate to="/uebersicht" replace />;
  }
  return children;
}
